"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports["default"] = exports.POPOVER_CONTAINER_CLASS = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _reactTinyPopover = require("react-tiny-popover");
var _automationHooks = require("@airportlabs/automation-hooks");
var _helpers = require("../helpers");
var _excluded = ["children", "triggerWidth", "triggerW", "gap", "onClose", "onOpen", "onOpenEffect", "renderTrigger", "automationHook", "theme"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var propTypes = {
  /** Will be the content of the Popover. Will receive the following props: popoverState, closePopover, openPopover, isOpen */
  children: _propTypes["default"].func.isRequired,
  /** Function that renders the trigger of the popover. Will receive the following props: togglePopover, openPopover, closePopover, isOpen  */
  renderTrigger: _propTypes["default"].func.isRequired,
  /** DEPRECATED: Optional width of the popover trigger wrapper.. Use "triggerW" */
  triggerWidth: _propTypes["default"].string,
  /** Optional width of the popover trigger wrapper. */
  triggerW: _propTypes["default"].string,
  /** Gap between trigger and card. Should be a valid theme spacing: "xs", "s", "base" etc. */
  gap: _propTypes["default"].string,
  /** Optional function to be executed when Popover closes. */
  onClose: _propTypes["default"].func,
  /** Optional function to be executed when Popover opens. */
  onOpen: _propTypes["default"].func,
  /** Optional. Wether you want to run onOpen as an useEffect. Useful if we want
   * to access popover content refs. */
  onOpenEffect: _propTypes["default"].bool,
  /** https://github.com/alexkatz/react-tiny-popover#popover */
  positions: _propTypes["default"].arrayOf(_propTypes["default"].oneOf(["top", "bottom", "left", "right"])),
  /** https://github.com/alexkatz/react-tiny-popover#popover */
  align: _propTypes["default"].oneOf(["start", "center", "end"]),
  /**
   * Used for automation testing
   * Will append the `popover-trigger` suffix
   */
  automationHook: _propTypes["default"].string,
  /** A custom theme passed to the component directly instead of being made
   * available through a ThemeProvider context  */
  theme: _propTypes["default"].object
};
exports.propTypes = propTypes;
var defaultProps = {
  positions: ["bottom", "top", "left", "right"],
  align: "start"
};
var POPOVER_CONTAINER_CLASS = "react-tiny-popover-container";
exports.POPOVER_CONTAINER_CLASS = POPOVER_CONTAINER_CLASS;
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "PopoverBase__Wrapper",
  componentId: "sc-k6ctja-0"
})(["width:", ";"], function (props) {
  return props.w;
});
var TriggerWrapper = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(Wrapper, _extends({
    ref: ref
  }, props));
});
var PopoverBase = function PopoverBase(_ref) {
  var _ref2, _currentTheme$spaces$, _currentTheme$spaces$2, _theme$spaces$gap;
  var children = _ref.children,
    triggerWidth = _ref.triggerWidth,
    _ref$triggerW = _ref.triggerW,
    triggerW = _ref$triggerW === void 0 ? "100%" : _ref$triggerW,
    gap = _ref.gap,
    onClose = _ref.onClose,
    onOpen = _ref.onOpen,
    onOpenEffect = _ref.onOpenEffect,
    renderTrigger = _ref.renderTrigger,
    automationHook = _ref.automationHook,
    theme = _ref.theme,
    popoverProps = _objectWithoutProperties(_ref, _excluded);
  (0, _helpers.useDeprecate)({
    triggerWidth: triggerWidth
  }, "PopoverBase");
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var currentTheme = (0, _styledComponents.useTheme)();
  var gapValue = (_ref2 = (_currentTheme$spaces$ = currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$spaces$2 = currentTheme.spaces[gap]) === null || _currentTheme$spaces$2 === void 0 ? void 0 : _currentTheme$spaces$2.replace("px", "")) !== null && _currentTheme$spaces$ !== void 0 ? _currentTheme$spaces$ : theme === null || theme === void 0 ? void 0 : (_theme$spaces$gap = theme.spaces[gap]) === null || _theme$spaces$gap === void 0 ? void 0 : _theme$spaces$gap.replace("px", "")) !== null && _ref2 !== void 0 ? _ref2 : "";
  var paddingProp = gapValue ? {
    padding: parseInt(gapValue, 10)
  } : {};

  // Running "onOpen" in useEffect to make sure the Popover is rendered by the
  // time the useEffect has run. Useful if we want to access popover content
  // refs.
  (0, _react.useEffect)(function () {
    if (isOpen && onOpenEffect) {
      onOpen === null || onOpen === void 0 ? void 0 : onOpen();
    }
  }, [isOpen, onOpen, onOpenEffect]);

  // "onClose" is not run as an effect because the Popover renders as closed
  // initially, and we only want "onClose" to run when the Popup has been recently
  // closed.
  var togglePopover = (0, _react.useCallback)(function () {
    setIsOpen(function (prev) {
      if (prev) {
        onClose === null || onClose === void 0 ? void 0 : onClose();
      }
      return !prev;
    });
  }, [onClose]);
  var openPopover = (0, _react.useCallback)(function () {
    if (!isOpen) {
      onOpen === null || onOpen === void 0 ? void 0 : onOpen();
    }
    setIsOpen(true);
  }, [onOpen, isOpen]);
  var closePopover = (0, _react.useCallback)(function () {
    if (isOpen) {
      onClose === null || onClose === void 0 ? void 0 : onClose();
    }
    setIsOpen(false);
  }, [onClose, isOpen]);
  return /*#__PURE__*/_react["default"].createElement(_reactTinyPopover.Popover, _extends({
    onClickOutside: closePopover
    // Used to determine the click context
    ,
    containerClassName: POPOVER_CONTAINER_CLASS,
    containerStyle: {
      zIndex: 9999
    }
  }, paddingProp, popoverProps, {
    isOpen: isOpen,
    content: function content(popoverState) {
      return children({
        popoverState: popoverState,
        closePopover: closePopover,
        openPopover: openPopover,
        isOpen: isOpen
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(TriggerWrapper, _extends({
    w: triggerW !== null && triggerW !== void 0 ? triggerW : triggerWidth
  }, (0, _automationHooks.hook)(automationHook, "popover-trigger")), renderTrigger({
    togglePopover: togglePopover,
    openPopover: openPopover,
    closePopover: closePopover,
    isOpen: isOpen
  })));
};
PopoverBase.defaultProps = defaultProps;
PopoverBase.propTypes = propTypes;
PopoverBase.displayName = "PopoverBase";
PopoverBase.containerClass = POPOVER_CONTAINER_CLASS;
var _default = PopoverBase;
exports["default"] = _default;